module.exports = __webpack_public_path__ + "img/backgroundHome.eba2b320.png";